export default __webpack_public_path__ + "c0299db39b31541e58d3891cc80868bc.webp";